/**
 * Placing a point on a sheet's page image (the Drawings viewer's Add to and the location picker's Drawing tab).
 * Points are the click's offset over the image's rendered size, which is page space (R19) because the image keeps the
 * page's aspect. Before the image has loaded it can still have a box (its alt text), so a click then would read as a
 * point near the top-left corner: nothing is placed until the image is loaded and rendered.
 */
interface SheetImage {
  complete?: boolean;
  naturalWidth?: number;
  clientWidth?: number;
  clientHeight?: number;
}

export function sheetImageReady(img: SheetImage | null | undefined): boolean {
  return !!img && img.complete !== false && (img.naturalWidth ?? 0) > 0 && (img.clientWidth ?? 0) > 0 && (img.clientHeight ?? 0) > 0;
}

/** The clicked spot in page space (0–1, clamped), or null when the image is not ready. */
export function sheetPointFromClick(event: MouseEvent): { x: number; y: number } | null {
  const img = event?.target as SheetImage | null;
  if (!sheetImageReady(img)) {
    return null;
  }
  const clamp = (v: number) => Math.min(1, Math.max(0, v));
  return { x: clamp(event.offsetX / img.clientWidth), y: clamp(event.offsetY / img.clientHeight) };
}
